module.exports = __webpack_public_path__ + "static/media/IMG_7067.b86ad65d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/square/IMG_7067.jpg
// module id = 143
// module chunks = 0